import { useMemo } from 'react'
import { useGetProjectModerationUserCandidatesQuery } from '../../../api/projects'
import {
  RestrictionUserPicker,
  type RestrictionUserPickerCopy,
} from './RestrictionUserPickerView'
import type {
  RestrictionUserCandidate,
  SelectedRestrictionUser,
} from './restrictionUserUtils'

const PROJECT_COPY: RestrictionUserPickerCopy = {
  emptyHint:
    'Пока нет авторов комментариев вне команды — найдите пользователя по имени профиля (@...) или ссылке.',
  withSuggestionsHint: 'Введите имя профиля (@...) или выберите из связанных с проектом.',
  suggestionsTitle: 'Связанные с проектом',
  suggestionsSubtitle: 'Авторы комментариев вне команды',
}

type Props = {
  projectId: number
  selectedUser: SelectedRestrictionUser | null
  onSelectedUserChange: (user: SelectedRestrictionUser | null) => void
  submitError?: string | null
}

export function ProjectRestrictionUserPicker({
  projectId,
  selectedUser,
  onSelectedUserChange,
  submitError = null,
}: Props) {
  const { data, isFetching } = useGetProjectModerationUserCandidatesQuery(
    { projectId },
    { skip: !projectId },
  )

  const candidates = useMemo((): RestrictionUserCandidate[] => {
    const result: RestrictionUserCandidate[] = []
    for (const item of data?.items ?? []) {
      const id = Number(item.user_id ?? item.id)
      if (!Number.isSafeInteger(id) || id <= 0) continue
      result.push({
        id,
        slug: item.slug ?? null,
        fullname: item.fullname ?? null,
        shortname: item.shortname ?? null,
        avatar: item.avatar ?? null,
        restrictable: item.restrictable,
        restrictable_reason: item.restrictable_reason ?? null,
      })
    }
    return result
  }, [data?.items])

  return (
    <RestrictionUserPicker
      selectedUser={selectedUser}
      onSelectedUserChange={onSelectedUserChange}
      candidates={candidates}
      isFetching={isFetching}
      copy={PROJECT_COPY}
      submitError={submitError}
    />
  )
}
